import React, { Component } from "react";
import { MetaTags } from "react-meta-tags";
import Banner from "./Banner";
import Topnav from "../common/Topnav";
import Programs from "../home-2/Programs";
import AboutSec from "../home-2/AboutSec";
import AlumniSec from "../home-2/AlumniSec";
import Awards from "../home-2/Awards";
import Placement from "../home-2/Placement";
import Recruiter from "../home-2/Recruiters";
import Sports from "../home-2/Sports";
import Events from "../home-2/Events";
import Footer from "../common/footer";
import News from "../home-2/News";
import Accred from "../home-2/Accred";
import BannerMob from "./BannerMob";

class Home2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,
      isMobile: false
    };
  }

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const isMobile = window.innerWidth <= 1000; // Common mobile breakpoint
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  };

  openModal = () => {
    this.setState({ showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { isMobile } = this.state;

    return (
      <>
        <MetaTags>{/* Meta tags content */}</MetaTags>
        {isMobile ? <BannerMob /> : <Banner />}
        <AboutSec />
        <Programs />
        <AlumniSec />
        <Awards />
        <Placement />
        <Recruiter />
        <Accred />
        <Sports />
        <Events />
        <News />
        <Footer />
      </>
    );
  }
}

export default Home2;